<template>
  <div>
    <v-layout wrap justify-center mt-12>
    </v-layout>
    <v-layout wrap justify-center mt-6>
      <v-flex xs12 sm8 text-center>
        <div class="mt-12">
          <img :src="images.success" height="300px">
        </div>
        <h3 class="secondary--text mt-12"><v-icon class="secondary--text mr-1">mdi-check</v-icon> {{ $t('v') }}</h3>
        <div class="mt-4 mb-8">{{ $t('w') }}</div>
        <v-btn to="/dossiers/create" class="mt-6 outlinedButtonWhiteBackground" outlined>
          <v-icon small class="mr-2">mdi-plus</v-icon>
          {{ $t('x') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

export default {
  data: () => ({
    images: {
      success: require('@/assets/app/images/businessman__flatline.svg'),
    },
  }),
}
</script>


<style scoped>
.stripe-card {
  /* width: 300px; */
  border: 1px solid grey;
  border-radius: 10px;
}

</style> 


<i18n>
{
  "fr": {
    "v": "Votre abonnement a été créé avec succès.",
    "w": "Vous pouvez désormais entièrement bénéficier de nos services.",
    "x": "Créer un nouveau dossier"
  },
  "en": {
    "v": "Your subscription was successfully created.",
    "w": "You can now fully use our services.",
    "x": "Transform a new CV"
  }
}
</i18n>